import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

export const NumberContainer = styled.div`
  display: flex;
  padding: ${pxToRem(10)};
  [data-narrow='true'] & {
    flex-wrap: wrap;
    > [data-type='number']:first-child {
      padding-top: ${pxToRem(40)} !important; /** css file conversion */
    }
    &[data-quantity='2'],
    &[data-quantity='3'] {
      flex-direction: column;
    }
  }
  .cssNumberTitle {
    font-size: ${pxToRem(18)}; /** css file conversion */
  }
`;

export const NumberComponentContainer = styled.div<{ showSparkline: boolean }>`
  align-self: center;
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 0%;
  height: 100%;
  justify-content: center;
  text-align: center;
  width: 100%;
  .cssNumberComponentValueLabelContainer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: ${({ showSparkline }) => (showSparkline ? 0 : `-${pxToRem(20)}`)};
  }
  /* Narrow widget with 2 numbers */
  [data-narrow='true'] > div > [data-quantity='2'] > & {
    .cssNumberComponentDisplayValue {
      max-height: ${pxToRem(40)};
    }
  }
  /* Narrow widget + short widget with 2 numbers */
  [data-narrow='true'][data-short='true'] > div > [data-quantity='2'] > & {
    .cssNumberComponentDisplayValue {
      max-height: ${pxToRem(30)};
    }
    .cssNumberComponentSparklineContainer {
      width: 100%;

      .highcharts-container,
      .highcharts-container .highcharts-root {
        height: ${pxToRem(30)} !important;
        margin-top: -2px !important;
      }
    }
  }
  /* Narrow + Short Widgets */
  [data-narrow='true'][data-extra-short='true'] > div > [data-quantity='2'] > &,
  [data-narrow='true'][data-short='true'] > div > [data-quantity='3'] > & {
    .cssNumberComponentDisplayValue {
      max-height: ${pxToRem(20)};

      > text {
        text-anchor: end;
      }
    }
    .cssNumberComponentDisplayValueHidden {
      font-size: ${pxToRem(14)};
      width: 50%;
    }
    .cssNumberComponentLabel,
    .cssNumberComponentTrendLabel {
      font-size: ${pxToRem(14)};
      margin-top: -${pxToRem(5)};
      text-align: left;
    }
    .cssNumberComponentSparklineContainer {
      width: 100%;

      .highcharts-container,
      .highcharts-container .highcharts-root {
        height: ${pxToRem(30)} !important;
      }
    }
    .cssNumberComponentValueLabelContainer {
      display: flex;

      .value {
        margin-right: calc(${pxToRem(20)} * -3);
        margin-left: ${pxToRem(20)};
      }
    }
  }
  /* Narrow widget with 3 numbers */
  [data-narrow='true'] > div > [data-quantity='3'] > & {
    .cssNumberComponentDisplayValue {
      max-height: ${pxToRem(20)};
    }
  }
  /* Narrow and extra short widget with 3 numbers */
  [data-extra-narrow='true'][data-short='true']
    > div
    > [data-quantity='3']
    > &
    [data-narrow='true'][data-extra-short='true']
    > div
    > [data-quantity='3']
    > & {
    .cssNumberComponentLabel,
    .cssNumberComponentTrendLabel {
      font-size: ${pxToRem(12)};
      margin-top: -${pxToRem(5)};
      text-align: left;
    }
    .cssNumberComponentValueLabelContainer {
      display: flex;

      .value {
        margin-right: calc(${pxToRem(20)} * -3);
        margin-left: ${pxToRem(20)};
      }
    }
    .cssNumberComponentSparklineContainer {
      width: 100%;

      .highcharts-container,
      .highcharts-container .highcharts-root {
        height: ${pxToRem(26)} !important;
        margin: -${pxToRem(5)} 0;
      }
    }
  }
  /* Extra Narrow Widgets */
  [data-narrow='true'][data-extra-narrow='true'] > div > [data-quantity='2'] > &,
  [data-narrow='true'][data-extra-narrow='true'] > div > [data-quantity='3'] > & {
    .cssNumberComponentLabel,
    .cssNumberComponentTrendLabel {
      font-size: ${pxToRem(12)};
      margin-top: -${pxToRem(5)};
    }
    .cssNumberComponentSparklineContainer {
      .highcharts-container,
      .highcharts-container .highcharts-root {
        margin: -${pxToRem(5)} 0;
      }
    }
  }

  /* Extra narrow + short widget with 3 numbers */
  [data-narrow='true'][data-extra-short='true'] > div > [data-quantity='3'] > &,
  [data-extra-narrow='true'][data-short='true'] > div > [data-quantity='3'] > & {
    .cssNumberComponentDisplayValue {
      max-height: ${pxToRem(14)};
    }
    .cssNumberComponentValueLabelContainer {
      .value {
        margin-right: calc(${pxToRem(5)} * -9);
        margin-left: -${pxToRem(5)};
      }
    }
    .cssNumberComponentSparklineContainer {
      .highcharts-container,
      .highcharts-container .highcharts-root {
        margin: -2px 0;
        height: ${pxToRem(26)} !important;
      }
    }
  }
  /* Extra Narrow + Extra Short Widgets */
  [data-narrow='true'][data-extra-narrow='true'][data-extra-short='true']
    > div
    > [data-quantity='2']
    > &,
  [data-narrow='true'][data-extra-narrow='true'][data-extra-short='true']
    > div
    > [data-quantity='3']
    > & {
    .cssNumberComponentDisplayValue {
      max-height: ${pxToRem(14)};
    }
    .cssNumberComponentLabel,
    .cssNumberComponentTrendLabel {
      font-size: ${pxToRem(12)};
      text-align: left;
    }
    .cssNumberComponentValueLabelContainer {
      .value {
        margin-right: calc(${pxToRem(10)} * -5);
        margin-left: -${pxToRem(5)};
      }
    }
    .cssNumberComponentSparklineContainer {
      .highcharts-container,
      .highcharts-container .highcharts-root {
        margin: -${pxToRem(5)} 0;
      }
    }
  }
  .cssNumberComponentLabelContainer {
    width: 100%;
    [data-number-dark='false'][data-invert='true'][data-custom-theme='true'] & {
      .cssNumberComponentLabel,
      .cssNumberComponentTrendLabel {
        color: #444 !important;
      }
    }
    .cssNumberComponentLabel {
      display: block;
      font-size: ${pxToRem(14)};
      width: 100%;
      white-space: nowrap;
    }
    .cssNumberComponentTrendLabel {
      display: block;
      font-size: ${pxToRem(16)};
      white-space: nowrap;
    }
  }
  .cssNumberComponentSparklineContainer {
    width: calc(100% - ${pxToRem(80)});
    max-width: ${pxToRem(300)};
    margin: auto;
    overflow: visible !important;
    [data-number-dark='false'][data-invert='true'][data-custom-theme='true'] & .highcharts-graph {
      stroke: #444;
    }
    .highcharts-container {
      overflow: visible !important;
      z-index: 1000000000;
      margin: auto;
    }
  }
`;

export const PopupContentContainer = styled.div`
  text-align: center;
`;

export const NumberDisplayContainer = styled.div`
  font-weight: bold;
  width: 100%;
  .cssNumberComponentDisplayValueHidden {
    display: none;
    font-size: ${pxToRem(40)};
    padding: ${pxToRem(5)};
  }
  .cssNumberComponentDisplayValue {
    max-height: ${pxToRem(110)};
    /* stylelint-disable value-keyword-case */
    fill: currentColor;

    [data-extra-short='true'] & {
      max-height: ${pxToRem(40)};
    }
    text {
      text-anchor: middle;
    }
    [data-number-dark='false'][data-invert='true'][data-custom-theme='true'] & {
      fill: #444;
    }
  }
`;
